// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".education-center__content .education-center__banner[data-v-c0e23dee]{margin-top:40px;margin-bottom:40px}@media (max-width:767px){.education-center__content .education-center__banner[data-v-c0e23dee]{margin-top:0;margin-bottom:30px}}", ""]);
// Exports
module.exports = exports;
